import React from "react";

export default function AlcairDal() {
  return (
    <>
      <h3>Alcair Dal is a call and response style song about the Seia Doon Warrior Society taunting everyone else.</h3>
      <p class="c2">
        <span>
          <p>Who strikes swift beneath the sun? - The Taardad do, until it's done!</p>
          <p>Who boasts loud but cannot last? - The Goshien do, they’re fading fast!</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>We taunt, we fight, our spirits burn,</p>
          <p>Honor we seek at every turn.</p>
          <p>We test the strength of foe and friend,</p>
          <p>Through blood and toil, until the end.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Who guards the path with eyes like flame? - The Seia Doon do, they’ve earned their name!</p>
          <p>Who claims the glory yet finds disgrace? - The Codarra do, they’ve lost their place!</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>We taunt, we fight, our spirits burn,</p>
          <p>Honor we seek at every turn.</p>
          <p>We test the strength of foe and friend,</p>
          <p>Through blood and toil, until the end.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Who drinks deep but leaves the dry? - The Nakai do, with their heads held high!</p>
          <p>Who speaks of glory but stumbles low? - The Reyn do, as their failures show!</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Who screams loud but flees the fray? - The Shaido do, they run away!</p>
          <p>Who claims honor yet breaks the land? - The Shaido do, with coward’s hand!</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>We taunt, we fight, our spirits burn,</p>
          <p>Honor we seek at every turn.</p>
          <p>We test the strength of foe and friend,</p>
          <p>Through blood and toil, until the end.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Who holds their spear through endless sand? - The Aiel do, with steady hand.</p>
          <p>Who laughs at death and shadows near? - The Aiel do, we have no fear!</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>We taunt, we fight, our spirits burn,</p>
          <p>Honor we seek at every turn.</p>
          <p>We test the strength of foe and friend,</p>
          <p>Through blood and toil, until the end.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Who dances still beneath the sun?</p>
          <p>The Aiel do, till all is done!</p>
        </span>
      </p>
    </>
  );
}
